// extracted by mini-css-extract-plugin
export default {"inner":"Form_inner__U-os8","inputs":"Form_inputs__RVnpx","divider":"Form_divider__wtBw5"};